function injectStyle (context) {
  require("!!../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-798fcdb8\",\"scoped\":true,\"sourceMap\":false}!../vue-loader/lib/selector?type=styles&index=0!./vue-datepicker.vue")
}
/* script */
export * from "!!babel-loader!../vue-loader/lib/selector?type=script&index=0!./vue-datepicker.vue"
import __vue_script__ from "!!babel-loader!../vue-loader/lib/selector?type=script&index=0!./vue-datepicker.vue"
/* template */
import {render as __vue_render__, staticRenderFns as __vue_static_render_fns__} from "!!../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-798fcdb8\",\"hasScoped\":true,\"buble\":{\"transforms\":{}}}!../vue-loader/lib/selector?type=template&index=0!./vue-datepicker.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-798fcdb8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
import normalizeComponent from "!../vue-loader/lib/runtime/component-normalizer"
var Component = normalizeComponent(
  __vue_script__,
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-datepicker2/vue-datepicker.vue
// module id = ipUw
// module chunks = 1